mutation AddTemplate($zipUrl: String!, $clientId: ID!, $campaignId: ID) {
    addMasterTemplate(temporaryBucketZipPath: $zipUrl, clientId: $clientId, campaignId: $campaignId) {
        _id
        adType
        persistentKey
    }
}
